import React from 'react';
import Button from '@material-ui/core/Button';
import DownloadforOfflineOutlined from '@mui/icons-material/DownloadForOfflineOutlined';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { selectDeedById } from 'entities/deed/selectors';
import type { State } from 'reducers';
import { downloadFileFromApi } from 'utils/downloadFileFromApi';

type RouteParams = {
  id: string;
  type: string;
};

export const ExportInterestedUsersButton = () => {
  const { id } = useParams<RouteParams>();
  const deed = useSelector((state: State) => selectDeedById(state, id));

  return (
    <Button
      onClick={() =>
        downloadFileFromApi(
          `api/deeds/${deed.id}/externalLinkFollows/export`,
          `interested-users-${deed.name}.csv`
        )
      }
      endIcon={<DownloadforOfflineOutlined />}
      title="Download interested users CSV file"
    >
      Export Interested Users
    </Button>
  );
};
